export const rootPath = "/"
export const blogPath = "/blog"
export const aboutPath = "/about"
export const cityPath = "/cities/:cityName"
